import { render, staticRenderFns } from "./agv-tag-li-image.vue?vue&type=template&id=1cdb4cf2&scoped=true&lang=pug&"
import script from "./agv-tag-li-image.vue?vue&type=script&lang=js&"
export * from "./agv-tag-li-image.vue?vue&type=script&lang=js&"
import style0 from "./agv-tag-li-image.vue?vue&type=style&index=0&id=1cdb4cf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdb4cf2",
  null
  
)

export default component.exports